module.exports = {
    Auth: {
        region: 'ap-northeast-1',
        userPoolId: 'ap-northeast-1_gKCJRRD0L',
        userPoolWebClientId: '3qg9egstnd7t5nqh5hpl8407m',
        authenticationFlowType: 'USER_PASSWORD_AUTH',
    }
}
